import React from 'react';

import HomeIcon from '@material-ui/icons/Home';
import BuildIcon from '@material-ui/icons/Build';
import CartIcon from '@material-ui/icons/ShoppingBasket';

import themes from './themes';
export const configuredTheme = themes[0].theme;

export const configuredLayout = {
  currentLayout: 'compact',
  notificationsOpen: false
};

const iconStyle = {
  fontSize: 32
};

export const menuItems = [
  {
    title: 'Orders',
    href: '/orders',
    icon: <HomeIcon style={iconStyle} />
  },
  {
    title: 'Products',
    href: '/products',
    icon: <CartIcon style={iconStyle} />
  },
  {
    title: 'Settings',
    href: '/settings',
    icon: <BuildIcon style={iconStyle} />
  }
];



// WEBPACK FOOTER //
// ./src/config.js